import axiosHelper from '@/utils/axiosHelper'

export default {
  // 获取所有Code数据组
  getAllCodes: async function () {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/Code.GetAllCodes', {
    })
    if (rtnObj.error === '000000') {
      for (let i = 0; i < rtnObj.data.length; i++) {
        for (let j = 0; j < rtnObj.data[i].array.length; j++) {
          if (rtnObj.data[i].array[j].type === '0') {
            continue
          } else if (rtnObj.data[i].array[j].type === '1' || rtnObj.data[i].array[j].type === '2') {
            if (rtnObj.data[i].array[j].code) {
              try {
                rtnObj.data[i].array[j].code = parseFloat(rtnObj.data[i].array[j].code)
                if (isNaN(rtnObj.data[i].array[j].code)) {
                  rtnObj.data[i].array[j].code = 0
                }
              } catch (err) {
                rtnObj.data[i].array[j].code = 0
              }
            } else {
              rtnObj.data[i].array[j].code = null
            }
          } else if (rtnObj.data[i].array[j].type === '3') {
            if (rtnObj.data[i].array[j].code && rtnObj.data[i].array[j].code === '1') {
              rtnObj.data[i].array[j].code = 1
            } else {
              rtnObj.data[i].array[j].code = 0
            }
          } else if (rtnObj.data[i].array[j].type === '4') {
            try {
              rtnObj.data[i].array[j].code = new Date(rtnObj.data[i].array[j].code)
            } catch (err) {
              rtnObj.data[i].array[j].code = null
            }
          } else {
            continue
          }
        }
      }
      const codesDic = {}
      for (let i = 0; i < rtnObj.data.length; i++) {
        codesDic[rtnObj.data[i].codeNumber] = rtnObj.data[i].array
      }
      return codesDic
    } else {
      return {}
    }
  },

  // 获取Code数据组
  getCodes: async function (codes) {
    const rtnObj = await axiosHelper.handle('/WebSYSAction/Code.GetCodes', {
      codes: codes
    })
    if (rtnObj.error === '000000') {
      for (let i = 0; i < rtnObj.data.length; i++) {
        for (let j = 0; j < rtnObj.data[i].array.length; j++) {
          if (rtnObj.data[i].array[j].type === '0') {
            continue
          } else if (rtnObj.data[i].array[j].type === '1' || rtnObj.data[i].array[j].type === '2') {
            if (rtnObj.data[i].array[j].code) {
              try {
                rtnObj.data[i].array[j].code = parseFloat(rtnObj.data[i].array[j].code)
                if (isNaN(rtnObj.data[i].array[j].code)) {
                  rtnObj.data[i].array[j].code = 0
                }
              } catch (err) {
                rtnObj.data[i].array[j].code = 0
              }
            } else {
              rtnObj.data[i].array[j].code = null
            }
          } else if (rtnObj.data[i].array[j].type === '3') {
            if (rtnObj.data[i].array[j].code && rtnObj.data[i].array[j].code === '1') {
              rtnObj.data[i].array[j].code = 1
            } else {
              rtnObj.data[i].array[j].code = 0
            }
          } else if (rtnObj.data[i].array[j].type === '4') {
            try {
              rtnObj.data[i].array[j].code = new Date(rtnObj.data[i].array[j].code)
            } catch (err) {
              rtnObj.data[i].array[j].code = null
            }
          } else {
            continue
          }
        }
      }
      const codesDic = {}
      for (let i = 0; i < rtnObj.data.length; i++) {
        codesDic[rtnObj.data[i].codeNumber] = rtnObj.data[i].array
      }
      return codesDic
    } else {
      return {}
    }
  },

  // 从Code数据组中获取特定Code数据
  getCode: function (codes, codeNumber, filterCodeAry) {
    if (codes[codeNumber]) {
      if (!filterCodeAry) {
        return codes[codeNumber]
      } else {
        const newCodeAry = []
        for (let i = 0; i < codes[codeNumber].length; i++) {
          for (let j = 0; j < filterCodeAry.length; j++) {
            if (codes[codeNumber][i].code === filterCodeAry[j]) {
              newCodeAry.push(codes[codeNumber][i])
              break
            }
          }
        }
        return newCodeAry
      }
    } else {
      return []
    }
  }
}
